import React from "react";
import Layout from "./layout";
import { URLS } from "../_config"
import Breadcrumbs from "../components/breadcrumbs/Breadcrumbs"

import { Tab, Nav, Card, Form, Button, Row, Col } from "react-bootstrap";

const Mylos: React.FC = () => {
  return (
    <Layout>
      <div data-aos="fade-up" data-aos-duration="1000">
      <Breadcrumbs title="My Account"
                breadcrumbs={{ Home: URLS.PROFILE, 'My Account': URLS.MYLOS }} />

        <Tab.Container defaultActiveKey="first">
          <Row>
            <Col sm={3}>
              <div className="profile-details-block height_auto">
                <div className="d-flex justify-content-center flex-column align-items-center">
                  <div className="profile-pic-upload mb-4">
                    <img
                      className="rounded-circle avatar-xl"
                      alt="200x200"
                      src="assets/images/users/avatar-2.jpg"
                      data-holder-rendered="true"
                    />
                  </div>
                  <h5>Kim Kircher (Director)</h5>
                  <div className="email-block">
                    <p className="d-flex align-items-center gap-2">
                      <i className="prof-mail-icon"></i> kkircher@securedmp.com
                    </p>
                  </div>
                  <p className="d-flex align-items-center gap-2">
                    <i className="prof-phone-icon"></i> 858-952-8133
                  </p>
                </div>
              </div>
              <Nav variant="pills" className="flex-column vr-tabs-panel mt-3 height_auto">
                <Nav.Item>
                  <Nav.Link eventKey="first">
                    <span className="tabs-number">1</span> My Signature
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="second">
                    <span className="tabs-number">2</span> Your Referral Link
                  </Nav.Link>

                  <Nav.Link eventKey="third">
                    <span className="tabs-number">3</span> Joined LOS
                  </Nav.Link>
                  <Nav.Link eventKey="forth">
                    <span className="tabs-number">4</span> Your Stats
                  </Nav.Link>
                  <Nav.Link eventKey="fifth">
                    <span className="tabs-number">5</span> Leaderboard
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </Col>
            <Col sm={9}>
              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <div
                    className="tab-pane fade show active"
                    id="v-pills-home"
                    role="tabpanel"
                    aria-labelledby="v-pills-home-tab"
                  >
                    <div className="card mb-3">
                      <div className="card-body p-0">
                        <div className="row mr-0">
                          <div className="col-lg-8 col-md-8">
                            <div className="p-3">
                              <div className="section-heading d-flex align-items-center justify-content-between pl-2">
                                <h2>My Signature</h2>
                                <a href="#">
                                  <img src="assets/images/my_los/dots.svg" />
                                </a>
                              </div>
                              <div>
                                <img src="assets/images/my_los/01.png" />
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-4 purple_bg">
                            <div className="p-3">
                              <div className="section-heading">
                                <h2>Preview</h2>
                              </div>
                              <div className="min_h180"></div>
                              <div className="d-flex justify-content-center">
                                <button
                                  type="submit"
                                  className="btn btn-primary w-md btn-lg px-5"
                                >
                                  Save Signature
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-center">
                      <div className="signture_email">
                        <input
                          type="text"
                          placeholder="padams@nexamortgage.com"
                          className="form-control"
                        />
                        <button className="send_text">Send Test</button>
                      </div>
                    </div>
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  <div className="card">
                    <div className="card-body">
                      <div className="section-heading">
                        <h2>Your Referral Link</h2>
                      </div>
                    </div>
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="forth">
                  <div className="card">
                    <div className="card-body">
                      <div className="section-heading">
                        <h2>Your Stats</h2>
                      </div>
                    </div>
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="third">
                  <div className="card">
                    <div className="card-body">
                      <div className="section-heading">
                        <h2>Joined LOS</h2>
                      </div>
                    </div>
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="fifth">
                  <div className="card">
                    <div className="card-body">
                      <div className="section-heading">
                        <h2>Leaderboard</h2>
                      </div>
                    </div>
                  </div>
                </Tab.Pane>
              </Tab.Content>

              <Tab.Container id="left-tabs-example" defaultActiveKey="first9">
                <Row>
                  <Col sm={8} className="mt-4">
                    <Tab.Content>
                      <Tab.Pane eventKey="first9">
                        <div className="card">
                          <div className="card-body">
                            <div className="section-heading pl-2">
                              <h2>Custom Header</h2>
                            </div>
                            <div className="drop_your_file">
                              <div id="dropzone">
                                <form
                                  action="/upload"
                                  className="dropzone needsclick"
                                  id="demo-upload"
                                >
                                  <div className="dz-message needsclick">
                                    <span className="text">
                                      <img
                                        src="assets/images/my_los/upload.svg"
                                        alt="Camera"
                                      />
                                      <span className="text-accent">
                                        Upload
                                      </span>{" "}
                                      or drop your file here
                                    </span>
                                    <span className="plus">+</span>
                                  </div>
                                  <a href="#" className="dropzone_close">
                                    <img src="assets/images/my_los/close.svg" />
                                  </a>
                                </form>
                              </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-center">
                              <div className="custom-control custom-checkbox custom-checkbox-lg  custom-checkbox-primary mb-3 d-flex align-items-center">
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  id="customCheckcolor2"
                                />
                                <label
                                  className="custom-control-label pt-0"
                                  htmlFor="customCheckcolor2"
                                >
                                  Enable Header
                                </label>
                              </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-center gap-20">
                              <button className="btn btn-primary w-md btn-lg px-4">
                                SAVE
                              </button>
                              <button className="btn refresh_btn w-md btn-lg px-4">
                                Refresh
                              </button>
                            </div>
                          </div>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="second9">
                        <div className="card">
                          <div className="card-body">
                            <div className="section-heading">
                              <h2>Basic</h2>
                            </div>
                          </div>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="third9">
                        <div className="card">
                          <div className="card-body">
                            <div className="section-heading">
                              <h2>Social</h2>
                            </div>
                          </div>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="forth9">
                        <div className="card">
                          <div className="card-body">
                            <div className="section-heading">
                              <h2>Professional</h2>
                            </div>
                          </div>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="fifth9">
                        <div className="card">
                          <div className="card-body">
                            <div className="section-heading">
                              <h2>Buttons</h2>
                            </div>
                          </div>
                        </div>
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                  <Col sm={4}>
                    <Nav variant="pills" className="flex-column vr-tabs-panel mt-4 custom_tab">
                      <Nav.Item>
                        <Nav.Link eventKey="first9">
                          <span className="tabs-number">1</span> Custom Header
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second9">
                          <span className="tabs-number">2</span> Basic
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="third9">
                          <span className="tabs-number">3</span> Social
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="forth9">
                          <span className="tabs-number">4</span> Professional
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="fifth9">
                          <span className="tabs-number">5</span> Buttons
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </Col>
                </Row>
              </Tab.Container>
            </Col>
          </Row>
        </Tab.Container>
      </div>
    </Layout>
  );
};

export default Mylos;
